import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SplitPane from 'react-split-pane';
import Editor from './editor';
import WordSetUploader from './WordSetUploader';

class ImitatorAndEditor extends Component {
  constructor(props) {
    super();
  }

  render() {
    if (this.props.ShowImitation) {
      return (
        <div className="Writer-Section">
          <SplitPane split="vertical" defaultSize="50%">
            <div className="editor-pane">
              <Editor className="editor" />
            </div>
            <WordSetUploader />
          </SplitPane>
        </div>
      );
    } else {
      return (
        <div className="Writer-Section">
          <div className="editor-pane">
            <Editor className="editor" />
          </div>
          <div align="center">
            power by <a href="https://github.com/HomoSapienLCY">Chengyu Liu</a> and{' '}
            <a href="https://github.com/GX-CHEN">Gongxia Chen</a>
          </div>
        </div>
      );
    }
  }
}

ImitatorAndEditor.propTypes = {
  ShowImitation: PropTypes.bool
};

function mapStateToProps(state) {
  return { ShowImitation: state.ShowImitation };
}

export default connect(
  mapStateToProps,
  null
)(ImitatorAndEditor);



// WEBPACK FOOTER //
// ./src/containers/ImitatorAndEditor.js